import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { angela } from "../characters/Angela";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { pcLady } from "../characters/PCLady";
import { tom } from "../characters/Tom";
import { vanessa } from "../characters/Vanessa";
import { doPhoneRing, doTransition, doWaitImageByTime, isFollowingVanessaLead, isMCCheated } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaMCParkAfter } from "./V8";
import { V8VanessaCustomerHotel } from "./V8_VanessaCustomerHotel";

const v8 = images.v8;
export const V8VanessaMCPark = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V8VanessaMCBeachBefore`)) {

        if (Question.globalAnswers.v8FuckedAngela) {
            doTransition(images.v8.V8VanessaMCPark_0);
            vanessa.talk(`We are golden!`);
            vanessa.talk(`I can't believe how smooth everything went.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_2);
            mc.talk(`What can I say? You have a way of convincing people.`);
            doWaitImageByTime(images.v8.V8VanessaMCPark_1);
            vanessa.talk(`Check this out.`);

        } else {
            doTransition(images.v8.V8VanessaMCPark_3);
            vanessa.talk(`I can't believe you fucked that up!`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_5);
            mc.talk(`I just couldn't do that to the poor girl.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_3.partials.V8VanessaMCPark_3_p);
            vanessa.talk(`You realize that I'll probably have to bang that old grandpa now, right?`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_5);
            mc.talk(`Do you realize that you can always give up on that job?`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_6);
            vanessa.talk(`I've now reached a point where it's the principal of the matter. So no.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_8);
            mc.talk(`Well... There is going to be one lucky grandpa then.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_6.partials.V8VanessaMCPark_7);
            vanessa.talk(`Ha!`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_8);
            vanessa.talk(`Very funny!`);
            doPhoneRing();
            mc.talk(`...`);
            doPhoneRing();
            mc.talk(`That's yours.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_34);
            vanessa.talk(`Fuck, it's the grandpa.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_35);
            vanessa.talk(`Speak.`);
            vanessa.talk(`Ahem...`);
            vanessa.talk(`Ahem......`);
            vanessa.talk(`Sure.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_5);
            mc.talk(`...`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_8);
            vanessa.talk(`He wants me to meet him in a few minutes.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_8.partials.V8VanessaMCPark_8_p);
            vanessa.talk(`And I don't have any leverage on him!`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_8);
            mc.talk(`So just fuck him, I don't think it's an issue for you.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_3);
            vanessa.talk(`I don't have a choice now, do I?`);



        }
    } else if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {

        doTransition(v8.V8VanessaMCPark_11);
        mc.talk(`I'm here, what's going on?`);
        vanessa.talk(`Guess who got her job back!`);
        mc.talk(`What? Seriously?`);
        doWaitImageByTime(v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p, { putParent: true });
        mc.talk(`How did you manage that?`);
        ImageClass.setImage(v8.V8VanessaMCPark_9);
        vanessa.talk(`I did exactly what you told me.`);
        vanessa.talk(`I just gave him what he wants and didn't improvise.`);
        ImageClass.setImage(v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`Told you.`);
        mc.talk(`But hold on...`);
        mc.talk(`What exactly did he want at the end?`);
        ImageClass.setImage(v8.V8VanessaMCPark_9);
        await vanessa.setQuestion(new Question({ text: `Are you sure you want to hear? It's pretty naughty.`, options: { think: false }, key: `v8VanessaParkListenToCustomerDetails` })
            .option({ title: `Tell me`, key: true })
            .option({ title: `Don't tell me`, key: false }));


        if (Question.globalAnswers.v8VanessaParkListenToCustomerDetails) {
            ImageClass.setImage(v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
            mc.talk(`Of course. Tell me all the details.`);
            ImageClass.setImage(v8.V8VanessaMCPark_9);
            vanessa.talk(`Alright!`);
            ImageClass.setImage(v8.V8VanessaMCPark_9);
            //no before after for this scene because it will only be called from here.
            return jump(V8VanessaCustomerHotel, "V8VanessaCustomerHotel");

        } else {
            ImageClass.setImage(v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
            mc.talk(`You are right, I rather not hear it.`);
            mc.talk(`I'm just glad you got your job back and this little adventure is behind us.`);

        }


    } else {
        doTransition(v8.V8VanessaMCPark_3);
        mc.talk(`I'm here, what's going on?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
        vanessa.talk(`I'M FUCKING BORED!`);
        mc.talk(`...`);
        if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
            mc.talk(`And what should I do about that?`);
        } else {
            mc.talk(`So why are you texting me? Call Joey or something.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_3.partials.V8VanessaMCPark_3_p);
            vanessa.talk(`He is always at the gym!`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_5);
            mc.talk(`So... What do you want me to do about that?`);
        }
    }

    return jump(V8VanessaMCPark_1, "V8VanessaMCPark_1");

};
export const V8VanessaMCPark_1 = async (): Promise<any> => {
    if (Game.seenScenarios.includes("V8VanessaCustomerHotel")) {
        doTransition(v8.V8VanessaMCPark_9);
        vanessa.talk(`And that's it!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`Wow.`);
        await vanessa.setQuestion(new Question({ text: `Wow, what?`, options: { think: false }, key: `v8VanessaParkCustomerWasSympathetic` })
            .option({ title: `Sympathetic response`, key: true })
            .option({ title: `Cynical response`, key: false }));


        if (Question.globalAnswers.v8VanessaParkCustomerWasSympathetic) {
            mc.talk(`That sounded... Really humiliating.`);
            mc.talk(`Are you okay?`);
            doWaitImageByTime(v8.V8VanessaMCPark_3);
            vanessa.talk(`Are you serious with me?`);
            ImageClass.setImage(v8.V8VanessaMCPark_6);
            vanessa.talk(`I didn't tell you this so you'll start being all bitchy with me.`);
            vanessa.talk(`It's only humiliating if I'm feeling humiliated.`);
            ImageClass.setImage(v8.V8VanessaMCPark_8);
            vanessa.talk(`And I'm not!`);
            mc.talk(`Chill. I was just asking.`);
            ImageClass.setImage(v8.V8VanessaMCPark_13);
            vanessa.talk(`Bottom line is that I got my job back!`);

        } else {
            mc.talk(`So all I need to do is to get you fired for you to lick my balls?`);
            ImageClass.setImage(v8.V8VanessaMCPark_9);
            vanessa.talk(`All you gotta do is ask.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
            mc.talk(`Interesting...`);

        }

    }

    if (!Game.seenScenarios.includes(`V8VanessaMCBeachBefore`)) {

        doWaitImageByTime(images.v8.V8VanessaMCPark_12);
        vanessa.talk(`Onto a different subject!`);
        vanessa.talk(`Well... While sitting here I had a perfect idea!`);
        mc.talk(`Uh oh...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_8);
        mc.talk(`I don't know what to tell you.`);
        mc.talk(`Most folks think your ideas are insane.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_13);
        vanessa.talk(`What "folks"?`);
        mc.talk(`...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p_2);
        vanessa.talk(`Ugh! Just listen!`);

        if (isFollowingVanessaLead()) {
            return jump(V8VanessaMCPark_VanessaLeadingMC_2, "V8VanessaMCPark_VanessaLeadingMC_2");
        }
        vanessa.talk(`Remember our little agreement?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p);
        mc.talk(`I do.`);

        ImageClass.setImage(images.v8.V8VanessaMCPark_13);
        vanessa.talk(`I figured that since both of us are free right now...`);
        vanessa.talk(`You can task me to do something...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_13);
        vanessa.talk(`You know... Like maybe...`);
        vanessa.talk(`fuck someone!?!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_14);
        mc.talk(`Right now?`);
        mc.talk(`Seriously? That's why you brought me here?`);
        mc.talk(`That's not how it works.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_8);
        mc.talk(`You said that you'd follow my lead, not that I'd tell you do stuff that you already want to do!`);
        return jump(V8VanessaMCPark_MCLeadingVanessa, "V8VanessaMCPark_MCLeadingVanessa");
    }

    if (isFollowingVanessaLead()) {
        return jump(V8VanessaMCPark_VanessaLeadingMC, "V8VanessaMCPark_VanessaLeadingMC");
    }
    return jump(V8VanessaMCPark_MCLeadingVanessa, "V8VanessaMCPark_MCLeadingVanessa");
};
export const V8VanessaMCPark_VanessaLeadingMC = async (): Promise<any> => {
    if (Question.globalAnswers.v8FuckedAngela) {
        ImageClass.setImage(images.v8.V8VanessaMCPark_11);
        vanessa.talk(`You are really a man of your word!`);
        vanessa.talk(`I honestly believed you were bullshitting me when you said you'd follow my lead.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`Me? No way. I don't bullshit.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_11);
        vanessa.talk(`We are going to have so much fun!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9);
        vanessa.talk(`To be honest, I haven't even started.`);
        vanessa.talk(`This little maneuver wasn't really planned as you might have guessed by now.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`Yeah, I figured.`);
        mc.talk(`What was your original plan?`);


    } else {
        ImageClass.setImage(images.v8.V8VanessaMCPark_8.partials.V8VanessaMCPark_8_p, { putParent: true });
        vanessa.talk(`I'm starting to think you are full of bullshit!`);
        // ImageClass.setImage(images.v8.V8VanessaMCPark_6_p);
        if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {
            vanessa.talk(`You agreed to follow my lead and you keep refusing to do what I say.`);
        } else {
            vanessa.talk(`You agreed to follow my lead and so far you have refused to do anything!`);
            vanessa.talk(`I know you didn't fucked that dude's girlfriend the other day.`);
        }

        ImageClass.setImage(images.v8.V8VanessaMCPark_8);
        mc.talk(`Okay, relax.`);
        mc.talk(`I guess I didn't completely understand what's involved.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_4);
        vanessa.talk(`Don't play dumb.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_4);
        vanessa.talk(`At this point you already know who I am and what I'm about.`);
        vanessa.talk(`So if you want to call it off, fine.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
        vanessa.talk(`It was supposed to be fun.`);
        vanessa.talk(`And I was gonna hold up my end of the bargain by the way.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
        mc.talk(`I guess I just wasn't ready to fuck some innocent girl so you could blackmail her grandpa.`);
        mc.talk(`But I was serious with what I said; I'll follow your lead.`);

        ImageClass.setImage(images.v8.V8VanessaMCPark_4);
        vanessa.talk(`I ain't gonna lie, I planned to start slower.`);
        vanessa.talk(`As you know, this thing wasn't planned, but I still thought you had the balls to pull it off.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_8);
        mc.talk(`What's done is done.`);
        mc.talk(`So, are you going to tell me what your original plan was for me?`);

    }
    return jump(V8VanessaMCPark_VanessaLeadingMC_2, "V8VanessaMCPark_VanessaLeadingMC_2");
};
export const V8VanessaMCPark_VanessaLeadingMC_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8VanessaMCPark_12);
    if (Game.seenScenarios.includes(`V8VanessaMCBeachBefore`)) {
        vanessa.talk(`You know what?`);
        vanessa.talk(`I actually planned to hold off until tomorrow, but we can start now.`);
        doPhoneRing();
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        vanessa.talk(`Hold on.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35.partials.V8VanessaMCPark_36_p, { putParent: true });
        vanessa.talk(`Hahaha!`);
        vanessa.talk(`Hahahaha!`);
        vanessa.talk(`BYE!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_12);
        mc.talk(`What was that about?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_6.partials.V8VanessaMCPark_7, { putParent: true });
        vanessa.talk(`I'm going to meet grandpa in a few!`);
        mc.talk(`Are you really going to show him his grand-daughter photo covered with cum?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_13);
        vanessa.talk(`Duh!!! That's why we did it in the first place.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_12);
        vanessa.talk(`Ahem Ahem.`);
        vanessa.talk(`So as I was saying before he rudely interrupted me.`);

    } else {
        vanessa.talk(`Remember our little agreement?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p);
        mc.talk(`How can I forget?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_13);
        vanessa.talk(`So I figured... Since I'm bored, why not give you a small task.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p);
        mc.talk(`Right now?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15);
        vanessa.talk(`Why not? Are you in a hurry to go somewhere?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p);
        mc.talk(`Not really...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_13);

    }
    vanessa.talk(`So your first assignment is...`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_13);
    vanessa.talk(`To kiss the first girl that walks by.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_14);
    mc.talk(`Are you trying to get me arrested?`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_15);
    vanessa.talk(`Settle down cowboy.`);
    vanessa.talk(`Don't throw yourself on her. Talk to her, you know, some sweet talk.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_13);
    vanessa.talk(`You are a charming guy, do your magic.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_15);
    vanessa.talk(`You know what? I'll even make it easier for you.`);
    vanessa.talk(`Let's forget about the first girl that walks by, and change it to any girl that you see.`);
    vanessa.talk(`But she has to be here. I wanna see you in action.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_15.partials.V8VanessaMCPark_15_p);
    mc.talk(`Deal.`);

    return jump(V8VanessaMCPark_2, "V8VanessaMCPark_2");
};
export const V8VanessaMCPark_MCLeadingVanessa = async (): Promise<any> => {
    if (Question.globalAnswers.v8FuckedAngela) {
        ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`I'm starting to think I'm the sucker here.`);
        mc.talk(`You agreed to follow my lead and do as I say, but so far it seems like the roles are reversed.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9);
        vanessa.talk(`I already told you the circumstances were different.`);
        vanessa.talk(`We were already balls deep with that grandpa and that was the perfect opportunity to be done with it!`);
        vanessa.talk(`And yes... I appreciate your help!`);
        vanessa.talk(`You know, I could have easily fucked her boyfriend, but I didn't!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
        mc.talk(`Seriously? Is he even your type?`);

        // TODO: add renders
        // doWaitImageByTime(images.v8.V8VanessaMCPark_15);
        vanessa.talk(`Real talk?`);
        // doWaitImageByTime(images.v8.V8VanessaMCPark_3);
        vanessa.talk(`I'm going through withdrawal here.`);
        vanessa.talk(`I haven't had sex in so long!`);
        if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario) {
            // doWaitImageByTime(images.v8.V8VanessaMCPark_4);
            mc.talk(`Are you serious? I literally let you fuck that big guy!`);
            // doWaitImageByTime(images.v8.V8VanessaMCPark_5);
            vanessa.talk(`Come on, that was days ago!`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_9.partials.V8VanessaMCPark_9_p);
            mc.talk(`Wow. You need therapy.`);
            vanessa.talk(`Nah, just sexual healing!`);
            mc.talk(`...`);
            vanessa.talk(`Marvin fucking Gaye! Ugh... Why do I even try?`);
        } else {

        }

        // TODO: this render but with a bit mad face
        ImageClass.setImage(images.v8.V8VanessaMCPark_12);
    } else {
        ImageClass.setImage(images.v8.V8VanessaMCPark_3);
        vanessa.talk(`I'm starting to regret when I said I'd follow your lead.`);
        vanessa.talk(`This is obviously going to be REALLY boring.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
        vanessa.talk(`Like, are we going to sit around all day with our thumbs up our asses?`);
        vanessa.talk(`Not that I'd mind that right now, I'd take anything at this point.`);
        vanessa.talk(`I'm literally wasting away from withdrawal over here.`);

        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
    }
    return jump(V8VanessaMCPark_MCLeadingVanessa_2, "V8VanessaMCPark_MCLeadingVanessa_2");

};

export const V8VanessaMCPark_MCLeadingVanessa_2 = async (): Promise<any> => {
    vanessa.talk(`You need to start coming up with some interesting stuff we can do, because this is gonna get old real fast.`);
    let extraText = '!';
    if (Game.seenScenarios.includes(`V8VanessaMCBeachBefore`)) {
        extraText = '; you are keeping me busy.';

    }
    mc.talk(`Woah, chill!\nI didn't have the time to come up with anything${extraText}`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_12);
    vanessa.talk(`How long am I supposed to wait?`);
    // ImageClass.setImage(images.v8.V8VanessaMCPark_12_p); (mouth close)
    mc.talk(`I'll come up with something.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_3);
    vanessa.talk(`Just do it quick, because I'm getting bored.`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_4);
    vanessa.talk(`And please, involve some sex in it. Not some nerdy shit!`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_5);
    mc.talk(`I'll do my best.`);
    return jump(V8VanessaMCPark_2, "V8VanessaMCPark_2");
};

export const V8VanessaMCPark_2 = async (): Promise<any> => {

    if (isFollowingVanessaLead()) {
        doTransition(images.v8.V8VanessaMCPark_3);
        vanessa.talk(`Come onnnn pick someone already!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_4);
        mc.talk(`Relax, I'm looking for the perfect girl.`);
        doWaitImageByTime(images.v8.V8VanessaMCPark_17);
        mc.think(`What perfect timing!`);
        mc.talk(`I pick her!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_18);
        vanessa.talk(`Oh wow, nice pick!`);
        vanessa.talk(`Go work your magic Romeo, I'll be right here!`);
    } else {
        doWaitImageByTime(images.v8.V8VanessaMCPark_17);
        mc.think(`Wait... Is that... Alex?`);
        if (!Game.seenScenarios.includes(`V8VanessaMCBeachBefore`)) {
            mc.think(`I can't believe she is here! I just saw her.`);

        }
        ImageClass.setImage(images.v8.V8VanessaMCPark_5);
        mc.talk(`Hold on! I'll be right back!`);
    }



    return jump(V8VanessaMCPark_2_Alex, "V8VanessaMCPark_2_Alex");
};

export const V8VanessaMCPark_2_Alex = async (): Promise<any> => {
    if (isFollowingVanessaLead()) {
        doWaitImageByTime(images.v8.V8VanessaMCPark_20);
        mc.think(`This is perfect! Vanessa is too far to hear me.`);
    } else {

    }

    ImageClass.setImage(images.v8.V8VanessaMCPark_21);
    mc.talk(`Hey Alex!`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_22);
    alex.talk(`${mc.name}! What are you doing here?`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_24);
    alex.talk(`Are you stalking me?`);
    mc.talk(`What? No! It's just a coincidence!`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_23);
    alex.talk(`Haha, I know, I'm just teasing you.`);

    doWaitImageByTime(images.v8.V8VanessaMCPark_22);
    mc.talk(`So? How are the clothes?`);
    alex.talk(`The clothes...?`);
    mc.talk(`Yes... When I was at your place you said you are taking them for a spin.`);

    doWaitImageByTime(images.v8.V8VanessaMCPark_25);
    alex.talk(`Oh... Yeah...`);

    mc.talk(`Is there something wrong?`);
    alex.talk(`Not wrong... But there is something...`);
    mc.talk(`What is it?`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_25.partials.V8VanessaMCPark_25_p, { duration: 1.5 });
    alex.talk(`It's something that I wanted to do before you left my house...`);
    alex.talk(`But I hesitated...`);
    alex.talk(`I kicked myself for not doing it...`);
    mc.talk(`What's that?`);
    doWaitImageByTime(images.v8.V8VanessaMCPark_26);
    alex.talk(`I'll just show you...`);
    empty.think(`Alex hesitated for a second and then...`);
    doWaitImageByTime(images.v8.V8VanessaMCPark_27);
    mc.think(`Wow! Where did that come from?`);

    doWaitImageByTime(images.v8.V8VanessaMCPark_28);
    alex.talk(`That's what...`);

    alex.talk(`I hope it wasn't inappropriate...`);


    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v1.Room1, { shake: true, duration: 0 });
        pcLady.talk("Of course it was!", { method: "Over Chat" });
        pcLady.talk("What about Ann? Are you going to betray her like that?", { method: "Over Chat" });
        pcLady.talk("And Alex???\nSo much for best friends!", { method: "Over Chat" });
        mc.talk("I didn't finish.", { method: "On Chat" });
        pcLady.talk("I don't see what you can say to make it look better.", { method: "Over Chat" });
        mc.talk("You'll see. Just give me a minute to finish this part and I'll explain everything.", { method: "On Chat" });
        pcLady.talk("Oh! You better.", { method: "Over Chat" });
        mc.talk("All I can say for now, that at that point I was as surprised as you. And I reacted accordingly.", { method: "On Chat" });
        pcLady.talk("Go on, I'm listening.", { method: "Over Chat" });

    }
    doWaitImageByTime(images.v8.V8VanessaMCPark_28, null, 2);
    alex.talk(`I hope it wasn't inappropriate...`);
    if (mc.properties.annStatus === "gf") {
        mc.think(`Fuck! What about Ann?`);
        mc.think(`Should I just say yes? What if it's going to bite me in the ass...?`);
        if (Question.globalAnswers.v3KeepAnsweringChris) {
            let pastPresent = 'does have';
            if (Question.globalAnswers.V8AnnDateMCOkWithChris) {

                pastPresent = 'did have';
            }

            if (isMCCheated()) {

                mc.think(`But she ${pastPresent} Chris... Why can't I have someone that I don't have to hide from her?`);
            } else {
                mc.think(`But she ${pastPresent} have Chris...`);
            }

        } else {

        }
        mc.think(`It is just a kiss! I can always stop it before it goes too far.`);
        doWaitImageByTime(images.v8.V8VanessaMCPark_29);
        alex.talk(`Cat got your tongue?`);
        mc.talk(`Oh! No. Sorry, I was just thinking of something.`);


    } else {
        mc.think(`It wasn't.`);
        doWaitImageByTime(images.v8.V8VanessaMCPark_29);
        alex.talk(`I'm glad!`);
    }

    doWaitImageByTime(images.v8.V8VanessaMCPark_30);
    alex.talk(`It was nice seeing you again, but I really have to go.`);
    doWaitImageByTime(images.v8.V8VanessaMCPark_31);
    alex.talk(`Who knows? Maybe third time is the charm! Haha.`, { method: `Shouting` });




    return jump(V8VanessaMCPark_2_VanessaAfterAlex, "V8VanessaMCPark_2_VanessaAfterAlex");
};
export const V8VanessaMCPark_2_VanessaAfterAlex = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8VanessaMCPark_32, null, 2);
    vanessa.talk(`What?`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_33);
    vanessa.talk(`Who?`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_32_2);
    vanessa.talk(`How???`);
    ImageClass.setImage(images.v8.V8VanessaMCPark_35);
    if (isFollowingVanessaLead()) {

        mc.talk(`Why are you so surprised?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        mc.talk(`Wasn't that what you just asked me to do?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35);
        vanessa.talk(`It was! But I didn't except you to actually succeed!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_32_3);
        vanessa.talk(`I honestly thought you were gonna get slapped!`);
        vanessa.talk(`Or at least a kick to the balls.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35);
        vanessa.talk(`If I knew you'd pull that off I would have told you to fuck her on the fountain!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        mc.talk(`...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35);
        vanessa.talk(`Joking! Not joking.`);
        vanessa.talk(`Either way. I'm honestly both proud and surprised!`);
        vanessa.talk(`Well done!`);
    } else {
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        vanessa.talk(`Who the fuck is that?`);
        mc.talk(`Does it matter?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_32_3);
        vanessa.talk(`Oh course it matters! You can't go around fucking hot girls without telling me!`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        mc.talk(`Excuse me? Why do I have to tell you?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35);
        vanessa.talk(`So I could join, DUH.`);
        mc.talk(`Interesting...`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        vanessa.talk(`I just told you that I'm in withdrawal.`);
        mc.talk(`For what it's worth, I didn't fuck her, and I was surprised by that kiss as well.`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_35);
        vanessa.talk(`Don't ruin it.`);

    }
    // TODO: threesome conversation.
    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa) {
        // TODO: put renders
        vanessa.talk(`Well. I better go and get ready.`);
        vanessa.talk(`Tonight is going to be so exiting!`);
        if (Game.seenScenarios.includes(`V8VanessaMCConv`)) {
            mc.talk(`Oh, right, the threesome.`);
        } else {
            mc.talk(`What are you talking about?`);
            vanessa.talk(`The threesome! DUH!`);
            vanessa.talk(`Don't act like you haven't been waiting for it the entire day!`);
            mc.talk(`Oh, right.`);
        }
        mc.talk(`Is Joey really going to follow it through?`);
        ImageClass.setImage(images.v8.V8VanessaMCPark_34);
        vanessa.talk(`He has no choice.`);
        vanessa.talk(`That's what he has to do if he wants to fuck me.`);
        mc.talk(`You are so mean...`);
        mc.talk(`What if I had said no?`);
        vanessa.talk(`I would have kept denying sex from him until he would have found a way to convince you.`);
        if (Game.seenScenarios.includes(`V8VanessaMCPark_MCLeadingVanessa`)) {
            mc.talk(`Didn't you say you are going through a withdrawal?`);
            mc.talk(`Why deny an easy fuck?`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_35);
            vanessa.talk(`First, because it's fun.`);
            vanessa.talk(`And second, because he had promised it to me and never followed through.`);
            vanessa.talk(`Words have consequences you know.`);

        } else {
            ImageClass.setImage(images.v8.V8VanessaMCPark_34);
            mc.talk(`You are such a bitch.`);
            vanessa.talk(`Thank you!`);
            mc.talk(`...`);

        }
        if (Question.globalAnswers.v8FuckedAngela) {
            ImageClass.setImage(images.v8.V8VanessaMCPark_35);
            vanessa.talk(`Well. I'll see you later.`);
            vanessa.talk(`I hope you didn't waste all your sperm on ${angela.name}, haha.`);
            mc.talk(`I have more for you, if that's what you are asking.`);
            ImageClass.setImage(images.v8.V8VanessaMCPark_34);
            vanessa.talk(`My hero! That's what I wanted to hear!`);

        } else {

        }
    } else if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa === false) {
        vanessa.talk(`By the way, Joe told me you refused the threesome with us!`);
        mc.talk(`Yeah... Not really my thing.`);
        if (Question.globalAnswers.v8FuckedAngela) {
            vanessa.talk(`And to think I started to give you some credit...`);
        } else {
            vanessa.talk(`So boring!`);
        }
        vanessa.talk(`You do realize that's his only way to fuck me, right?`);
        vanessa.talk(`I bet he is going to call you later to try and convince you again.`);
        mc.talk(`I already gave my answer.`);
        vanessa.talk(`Well, think about that. It's going to be fun!`);


    }

    return jump(V8VanessaMCParkAfter, "V8VanessaMCParkAfter");
};
